import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VCol,
        { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { sm: "8", lg: "8" } },
                [
                  _c(VAutocomplete, {
                    attrs: {
                      items: _vm.pagedItems,
                      "item-text": function (i) {
                        return (i && (i.object_name || i.title || i.name)) || ""
                      },
                      "item-value": function (i) {
                        return i && (i.id != null ? i.id : i[_vm.idKey])
                      },
                      dense: "",
                      outlined: "",
                      clearable: "",
                      multiple: "",
                      label: "Buscar dataset",
                      "prepend-inner-icon": "mdi-magnify",
                    },
                    model: {
                      value: _vm.selectedTemp,
                      callback: function ($$v) {
                        _vm.selectedTemp = $$v
                      },
                      expression: "selectedTemp",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "2", lg: "2" } },
                [
                  !_vm.readonly
                    ? _c(
                        VBtn,
                        {
                          attrs: {
                            outlined: "",
                            color: "secondary",
                            small: "",
                            dense: "",
                            rounded: "",
                            disabled:
                              !_vm.selectedTemp ||
                              (Array.isArray(_vm.selectedTemp) &&
                                !_vm.selectedTemp.length),
                          },
                          on: { click: _vm.addSelected },
                        },
                        [_vm._v(_vm._s(_vm.$t("btns.add_item")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { sm: "12", lg: "12" } },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    attrs: {
                      headers: [
                        { text: "DATASETS SELECCIONADOS", value: "name" },
                        { text: "ACCIONES", value: "action", align: "center" },
                      ],
                      items: _vm.dsources,
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.action",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VBtn,
                              {
                                attrs: { icon: "", small: "", color: "error" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onRemoveDatasource(item)
                                  },
                                },
                              },
                              [_c(VIcon, [_vm._v("small mdi-delete")])],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }